// extracted by mini-css-extract-plugin
export default {"accordion-actions":"accordion-actions---x2IfU"};